export default {"src":"/_next/static/media/deploy-secure.6ca96094.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};